export * from './vehicle-configuration-compartment.model';
export * from './vehicle-configuration-compartment-command.model';